import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { navItemsData } from './data/navItems';
import HomePage from './pages/HomePage';
import AboutUsPage from './pages/AboutUsPage';
import ProductsPage from './pages/ProductsPage';
import SoftwarePage from './pages/SoftwarePage';
import NewsPage from './pages/NewsPage';
import KnowledgeBasePage from './pages/KnowledgeBasePage';
import ContactUsPage from './pages/ContactUsPage';
import ClientsPage from './pages/ClientsPage';
import ProductPage from './pages/products/ProductPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';

function AppContent() {
  const location = useLocation();
  const currentPage = location.pathname.replace('/', '') || 'home';
  let category = null;
  if (currentPage.startsWith('products/')) {
    category = currentPage.split('/')[1];
  }
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar currentPage={currentPage} />
      <main className="overflow-x-hidden">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:category" element={<ProductPage category={category} />} />
          <Route path="/software" element={<SoftwarePage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/knowledge" element={<KnowledgeBasePage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/clients" element={<ClientsPage />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;